import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { jsx as _jsx } from "react/jsx-runtime";
const PanelOverlay = ({
  hasOverlay,
  children
}) => hasOverlay ? /*#__PURE__*/_jsx(Overlay, {
  width: "100%",
  "data-test-id": "panel-overlay",
  children: children
}) : children;
export default PanelOverlay;